import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'panel', 'icon', 'content', 'showLabel', 'hideLabel'];
  static values = {
    open: Boolean,
    openClasses: String,
    closedClasses: String,
  };

  static animationDuration = 300;

  connect() {
    this.overflowTimer = null;
    this.apply(true);
  }

  disconnect() {
    if (this.overflowTimer) clearTimeout(this.overflowTimer);
  }

  toggle() {
    this.openValue = !this.openValue;
    this.apply();
    this.revealLazyFrames();
  }

  open() {
    this.openValue = true;
    this.apply();
  }

  close() {
    this.openValue = false;
    this.apply();
  }

  apply(immediate = false) {
    const open = this.openValue === true;

    if (this.overflowTimer) clearTimeout(this.overflowTimer);

    if (!open) {
      this.hideOverflow();
    }

    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle('grid-rows-[1fr]', open);
      this.panelTarget.classList.toggle('grid-rows-[0fr]', !open);
    }

    if (this.hasButtonTarget) {
      this.applyStateClasses(this.buttonTarget, open);
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('-rotate-180', open);
    }

    if (this.hasShowLabelTarget) {
      this.showLabelTarget.classList.toggle('hidden', open);
    }

    if (this.hasHideLabelTarget) {
      this.hideLabelTarget.classList.toggle('hidden', !open);
    }

    if (open) {
      this.loadLazyTurboFrames();

      if (immediate) {
        this.showOverflow();
      } else {
        this.overflowTimer = setTimeout(() => {
          this.showOverflow();
        }, this.constructor.animationDuration);
      }
    }
  }

  loadLazyTurboFrames() {
    this.element.querySelectorAll('turbo-frame[src][loading="lazy"]').forEach((frame) => {
      frame.loading = 'eager';
    });
  }

  applyStateClasses(element, open) {
    const openClasses = this.openClassesValue.split(/\s+/).filter(Boolean);
    const closedClasses = this.closedClassesValue.split(/\s+/).filter(Boolean);

    element.classList.remove(...openClasses, ...closedClasses);

    if (open && openClasses.length > 0) {
      element.classList.add(...openClasses);
    }

    if (!open && closedClasses.length > 0) {
      element.classList.add(...closedClasses);
    }
  }

  hideOverflow() {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.add('overflow-hidden');
    }

    if (this.hasContentTarget) {
      this.contentTarget.classList.add('overflow-hidden');
    }
  }

  showOverflow() {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove('overflow-hidden');
    }

    if (this.hasContentTarget) {
      this.contentTarget.classList.remove('overflow-hidden');
    }
  }

  revealLazyFrames() {
    if (!this.openValue || !this.hasPanelTarget) return;
    this.panelTarget.querySelectorAll('turbo-frame[hidden]').forEach((frame) => {
      frame.removeAttribute('hidden');
    });
  }
}
